import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { DsControlWiringIP, OptionsConnectedDef, SaveEventType, SaveStatusObj, SOModule, UserType, ValidationItem, ValidationSummary } from '../../../../shared/misc-classes';
import { DataService } from '../../../../shared/dataservice.service';
import { ValidationDialog } from '../../../../dialogs/validation-dialog/validation-dialog';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';

@Component({
  selector: 'ds-control-wiring',
  templateUrl: './ds-control-wiring.component.html',
  styleUrls: ['./ds-control-wiring.component.css']
})
export class DsControlWiringComponent implements OnInit, OnChanges {
  
    @Input() dsControlWiringObj: DsControlWiringIP;
    @Input() soLockObtained:boolean;
    @Input() accessLevel: Array<UserType>;
    @Output() updateDatasheet: EventEmitter<SaveStatusObj> = new EventEmitter();
    
    disableForm: boolean = false;
    inputDisableMessage: string = 'This form is not yet enabled';
    readonlyAccess : boolean = false;
    Hvr:any = {};
    hasAccessEE: boolean = false;
    hasAccessME: boolean = false;
    hasAccessPM: boolean = false;
    lockFields: boolean = false; // After HOM lock
  
    constructor(public _dataService: DataService, public dialog: MatDialog) { }
  
    ngOnInit(): void {
    }
    ngOnChanges(): void {
       this.disableForm = true;
      if(this.soLockObtained == false){
        this.inputDisableMessage = "You can't Edit";
      }
      else if (this.accessLevel.includes(this._dataService.userType) == false) {
      this.inputDisableMessage = "You don't have EDIT ACCESS.";
      }
      else {
        this.disableForm = false;
        // this.checkUserEnabled();
      }
      if(this._dataService.hasReadOnlyAccess){
        this.readonlyAccess = true;
      }
      this.hasAccessEE = this._dataService.userType === (UserType.ELECTRICAL_ENGINEERING) || this._dataService.userType === (UserType.MARKETING) || this._dataService.userType === (UserType.SUPER_ADMIN);
      this.hasAccessME = this._dataService.userType === (UserType.MECHANICAL_ENGINEERING) || this._dataService.userType === (UserType.MARKETING) || this._dataService.userType === (UserType.SUPER_ADMIN);
      this.hasAccessPM = this._dataService.userType === (UserType.PROJECT_MANAGEMENT) || this._dataService.userType === (UserType.MARKETING) || this._dataService.userType === (UserType.SUPER_ADMIN);
      if (!this.dsControlWiringObj.parentSORef.isDatasheetSubOrderEnabled) {
        this.lockFields = false;
      }
      else {
        this.lockFields = true;
      }
  
    }
   
  cachedApplicSt: any = {};
  filterApplicSt() {
    let _id = this.dsControlWiringObj.parentSORef.marketingIP.ordertypeId;
    if (this.cachedApplicSt[_id] != null) {
      return this.cachedApplicSt[_id];
    }
    this.cachedApplicSt[_id] = this._dataService.applicStand.filter((_obj: OptionsConnectedDef) => {
      if ((_obj.connectedOptionId.length == 0) || _obj.connectedOptionId.indexOf(_id) >= 0) {
        return true;
      }
      return false;
    });
    // return this.cachedApplicSt[_id];
    if (this.cachedApplicSt[_id] != null) {
      return this.cachedApplicSt[_id];
    }
    var _result = !this._dataService.isGeneralApplicStand(_id);
    this.cachedApplicSt[_id] = _result;
    return _result;
  }

  cachedInsuGrd: any = {};
  filterInsuGrd(_id) {
    if (this.cachedInsuGrd[_id] != null) {
      return this.cachedInsuGrd[_id];
    }
    this.cachedInsuGrd[_id] = this._dataService.insulationGrade.filter((_obj: OptionsConnectedDef) => {
      if ((_obj.connectedOptionId.length == 0) || _obj.connectedOptionId.indexOf(_id) >= 0) {
        return true;
      }
      return false;
    });
    // return this.cachedInsuGrd[_id];
    if (this.cachedInsuGrd[_id] != null) {
      return this.cachedInsuGrd[_id];
    }
    var _result = !this._dataService.isGeneralInsulationGrade(_id);
    this.cachedInsuGrd[_id] = _result;
    return _result;
  }

  sectionNoteChangePM(_event: any) {
    this.dsControlWiringObj.sectionNotePM = _event.target.value;
  }
  sectionNoteChangeEE(_event: any) {
    this.dsControlWiringObj.sectionNoteEE = _event.target.value;
  }
  sectionNoteChangeME(_event: any) {
    this.dsControlWiringObj.sectionNoteME = _event.target.value;
  }

  saveDS(_submitToNextSection:boolean){
      if(this.updateDatasheet){
        this.updateDatasheet.emit(new SaveStatusObj(SOModule.Marketing, 
            (_submitToNextSection == true ? SaveEventType.Submit_To_Next:SaveEventType.Save_Data)));
      }
    }
    reloadData(){
      if(this.updateDatasheet){
        this.updateDatasheet.emit(new SaveStatusObj(SOModule.Marketing, SaveEventType.Reload_Data));
      }
    }

  showSoValidation() {
    let _validList: Array<ValidationItem> = [];

    if (this.hasAccessEE) {
      _validList.push(
        new ValidationItem("Control Wire Type", !!this.dsControlWiringObj.conWireType, " required to save Datasheet."),
        new ValidationItem("Applicable Standard", !!this.dsControlWiringObj.applicStand, " required to save Datasheet."),
        new ValidationItem("Insulation Grade", !!this.dsControlWiringObj.insulationGrade, " required to save Datasheet."),
        new ValidationItem("Wire Type", !!this.dsControlWiringObj.wireTypeV2, " required to save Datasheet."),
        new ValidationItem("CT Circuit", !!this.dsControlWiringObj.ctCircuit, " required to save Datasheet."),
        new ValidationItem("CT Circuit Color", !!this.dsControlWiringObj.ctCircuitColor, " required to save Datasheet."),
        new ValidationItem("PT Circuit", !!this.dsControlWiringObj.ptCircuit, " required to save Datasheet."),
        new ValidationItem("PT Circuit Color", !!this.dsControlWiringObj.ptCircuitColor, " required to save Datasheet."),
        new ValidationItem("DC Control Circuit", !!this.dsControlWiringObj.dcConCircuit, " required to save Datasheet."),
        new ValidationItem("DC Control Circuit Color", !!this.dsControlWiringObj.dcConCircuitColor, " required to save Datasheet."),
        new ValidationItem("AC Control Circuit", !!this.dsControlWiringObj.acConCircuit, " required to save Datasheet."),
        new ValidationItem("AC Control Circuit Color", !!this.dsControlWiringObj.acConCircuitColor, " required to save Datasheet."),
        new ValidationItem("Earthing Wire", !!this.dsControlWiringObj.earthWire, " required to save Datasheet."),
        new ValidationItem("Hinge Door Earth", !!this.dsControlWiringObj.hingeDoorEarth, " required to save Datasheet."),
        new ValidationItem("Main DC Circuit", !!this.dsControlWiringObj.mainDCCirc, " required to save Datasheet."),
        new ValidationItem("Main AC Circuit", !!this.dsControlWiringObj.mainACCirc, " required to save Datasheet."),
        new ValidationItem("Ferrulling", !!this.dsControlWiringObj.ferrulling, " required to save Datasheet."),
        new ValidationItem("Ferrulling Material", !!this.dsControlWiringObj.ferrullingMat, " required to save Datasheet."),
        new ValidationItem("EE Note", !!this.dsControlWiringObj.sectionNoteEE, " required to save Datasheet.")
      );
      if (this.dsControlWiringObj.isConWireSpecReqApplicable) {
        _validList.push(new ValidationItem("Control Wire Detail", !!this.dsControlWiringObj.conWireTypeDetail, " required to save Datasheet."));
      }
      if (this.dsControlWiringObj.isWireTypeSpecReqApplicable) {
        _validList.push(new ValidationItem("Wire Type Detail", !!this.dsControlWiringObj.wireTypeV2Detail, " required to save Datasheet."));
      }
      if (this.dsControlWiringObj.isEarthWireSpecReqApplicable) {
        _validList.push(new ValidationItem("Earthing Wire Color", !!this.dsControlWiringObj.earthWireColor, " required to save Datasheet."));
      }
      if (this.dsControlWiringObj.isMainDCSpecReqApplicable) {
        _validList.push(new ValidationItem("Main DC Circuit Color", !!this.dsControlWiringObj.mainDCCircColor, " required to save Datasheet."));
      }
      if (this.dsControlWiringObj.isMainACSpecReqApplicable) {
        _validList.push(new ValidationItem("Main AC Circuit Color", !!this.dsControlWiringObj.mainACCircColor, " required to save Datasheet."));
      }
      if (this.dsControlWiringObj.isFerrSpecReqApplicable) {
        _validList.push(new ValidationItem("Ferrulling Material Detail", !!this.dsControlWiringObj.ferrullingMatDetail, " required to save Datasheet."));
      }
    }

    if (this.hasAccessPM) {
      _validList.push(new ValidationItem("PM Note", !!this.dsControlWiringObj.sectionNotePM, " required to save Datasheet."));
    }
    if (this.hasAccessME) {
      _validList.push(new ValidationItem("ME Note", !!this.dsControlWiringObj.sectionNoteME, " required to save Datasheet."));
    }

    let vSummaryObj: ValidationSummary = new ValidationSummary("Validation Summary.", _validList);
    this.dialog.open(ValidationDialog, { width: '50%', data: vSummaryObj });
  }

  saveSOValidation(): boolean {
    if (this.hasAccessEE) {
      if (!this.dsControlWiringObj.conWireType || !this.dsControlWiringObj.applicStand ||
        !this.dsControlWiringObj.insulationGrade || !this.dsControlWiringObj.wireTypeV2 ||
        !this.dsControlWiringObj.ctCircuit || !this.dsControlWiringObj.ctCircuitColor ||
        !this.dsControlWiringObj.ptCircuit || !this.dsControlWiringObj.ptCircuitColor ||
        !this.dsControlWiringObj.dcConCircuit || !this.dsControlWiringObj.dcConCircuitColor ||
        !this.dsControlWiringObj.acConCircuit || !this.dsControlWiringObj.acConCircuitColor ||
        !this.dsControlWiringObj.earthWire || !this.dsControlWiringObj.hingeDoorEarth ||
        !this.dsControlWiringObj.mainDCCirc || !this.dsControlWiringObj.mainACCirc ||
        !this.dsControlWiringObj.ferrulling || !this.dsControlWiringObj.ferrullingMat ||
        !this.dsControlWiringObj.sectionNoteEE) {
        return false;
      }
      if (this.dsControlWiringObj.isConWireSpecReqApplicable && !this.dsControlWiringObj.conWireTypeDetail) return false;
      if (this.dsControlWiringObj.isWireTypeSpecReqApplicable && !this.dsControlWiringObj.wireTypeV2Detail) return false;
      if (this.dsControlWiringObj.isEarthWireSpecReqApplicable && !this.dsControlWiringObj.earthWireColor) return false;
      if (this.dsControlWiringObj.isMainDCSpecReqApplicable && !this.dsControlWiringObj.mainDCCircColor) return false;
      if (this.dsControlWiringObj.isMainACSpecReqApplicable && !this.dsControlWiringObj.mainACCircColor) return false;
      if (this.dsControlWiringObj.isFerrSpecReqApplicable && !this.dsControlWiringObj.ferrullingMatDetail) return false;
    }
    if (this.hasAccessPM) {
      if (!this.dsControlWiringObj.sectionNotePM) return false;
    }
    if (this.hasAccessME) {
      if (!this.dsControlWiringObj.sectionNoteME) return false;
    }
    return true;
  }

}

